import { render } from "./partners-list.vue?vue&type=template&id=c6a2d042"
import script from "./partners-list.vue?vue&type=script&lang=js"
export * from "./partners-list.vue?vue&type=script&lang=js"

import "./partners-list.vue?vue&type=style&index=0&id=c6a2d042&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__